import React from 'react';

import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@material-ui/core';

import Eye from '../../../../assets/img/icon/Eye.svg';
// import Eye from '../../../../assets/img/icon/Eye.png';
import EyeInactive from '../../../../assets/img/icon/EyeInactive.png';
import SubHeader from '../../../../components/Header/SubHeader.component';
import Loader from '../../../../components/LoaderSplash/Loader.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import EditProfileDataProvider from '../../../../context/account/editProfile.provider';
import useChangePassword from './hooks';

const ChangePasswordWrapped = () => {
  const {
    loading,
    open,
    onClose,
    errors,
    onSubmit,
    submitErrors,
    handleChange,
    showPass,
    setShowPass,
    handleSubmit,
  } = useChangePassword();

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action="Cargando información personal" />
      </Box>

      <SharedDialog
        open={open}
        content={
          <Box>
            <Typography variant="h6">
              {' '}
              ¿Querés guardar los cambios en tu perfil?{' '}
            </Typography>
            <Typography>
              {' '}
              Recordá que de ahora en más vas a tener que usar la nueva
              contraseña para acceder a la app.{' '}
            </Typography>
          </Box>
        }
        onClose={onClose}
        actions={
          <Grid container>
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={onSubmit}
                >
                  Guardar cambios
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  onClick={onClose}
                >
                  Descartar
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <SubHeader
        content={
          <Box>
            <Typography variant="h6" color="textPrimary">
              {' '}
              Nueva contraseña{' '}
            </Typography>
            <Box my={2}>
              <Typography variant="caption">
                {' '}
                Recordá que de ahora en más vas a tener que usar la nueva
                contraseña para acceder a la app.{' '}
              </Typography>
            </Box>
          </Box>
        }
      ></SubHeader>

      <Box my={3}>
        <Grid container justify="center">
          <Grid item xs={11} md={8} lg={6}>
            <Box mt={2}>
              <Grid container>
                <Grid item xs={12} sm={8}>
                  <Box mr={2} mb={2}>
                    <Typography variant="subtitle2">
                      {' '}
                      Confirma tu contraseña actual{' '}
                    </Typography>
                    <TextField
                      size="small"
                      type="password"
                      error={
                        Boolean(errors['current_password']) ||
                        Boolean(submitErrors['change_password'])
                      }
                      helperText={
                        errors['current_password'] ||
                        submitErrors['change_password']
                      }
                      onChange={handleChange}
                      fullWidth={true}
                      name="current_password"
                      id="current_password"
                      placeholder="Ingresá tu contraseña"
                      variant="outlined"
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={8}>
                  <Box mr={2} mb={2}>
                    <Typography variant="subtitle2">
                      {' '}
                      Generá tu nueva contraseña *{' '}
                    </Typography>
                    <TextField
                      size="small"
                      type={showPass ? 'text' : 'password'}
                      error={Boolean(errors['password'])}
                      helperText={errors['password']}
                      onChange={handleChange}
                      name="password"
                      id="password"
                      placeholder="Ingresá tu contraseña"
                      variant="outlined"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={() => setShowPass(!showPass)}>
                              {showPass ? (
                                <img
                                  src={EyeInactive}
                                  alt="password hidden"
                                ></img>
                              ) : (
                                <img src={Eye} alt="show password"></img>
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      fullWidth
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={8}>
                  <Box mr={2} mb={2}>
                    <Typography variant="subtitle2">
                      {' '}
                      Repetíla una vez más *{' '}
                    </Typography>
                    <TextField
                      size="small"
                      type="password"
                      error={Boolean(errors['password_confirmation'])}
                      helperText={errors['password_confirmation']}
                      onChange={handleChange}
                      name="password_confirmation"
                      id="password_confirmation"
                      placeholder="Ingresá tu contraseña nuevamente"
                      variant="outlined"
                      fullWidth
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>

            <Box mb={4}>
              <FormControl
                required
                // error={error}
                component="fieldset"
                // className={classes.formControl}
              >
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!errors['minimum']}
                        disabled={errors['minimum']}
                        name="minimum"
                        color="primary"
                      />
                    }
                    label="Min 8 caracteres"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!errors['uppercase']}
                        disabled={errors['uppercase']}
                        name="uppercase"
                        color="primary"
                      />
                    }
                    label="Una mayúscula"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!errors['number']}
                        disabled={errors['number']}
                        name="number"
                        color="primary"
                      />
                    }
                    label="Un número"
                  />
                </FormGroup>
                {/* <FormHelperText>You can display an error</FormHelperText> */}
              </FormControl>
            </Box>

            <Box mb={4} mt={2}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                disabled={!!Object.keys(errors).length}
                onClick={handleSubmit}
              >
                Guardar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

const ChangePassword = () => (
  <EditProfileDataProvider>
    <ChangePasswordWrapped />
  </EditProfileDataProvider>
);

export default ChangePassword;
